var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-player" }, [
    _c("div", { ref: "stage", staticClass: "stage", style: _vm.stageStyle }, [
      _c(
        "div",
        { staticClass: "canvas", style: _vm.canvasStyle },
        [
          _vm.resolvedImage
            ? _c("img", {
                staticClass: "base-image",
                attrs: { src: _vm.resolvedImage, draggable: "false" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.resolvedOverlayImage
            ? _c("img", {
                staticClass: "overlay-image",
                style: _vm.overlayStyle,
                attrs: { src: _vm.resolvedOverlayImage, draggable: "false" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.resolvedLabels, function(label) {
            return [
              _c(
                "div",
                {
                  key: label.id,
                  staticClass: "label",
                  style: [_vm.rectStyle(label), _vm.labelStyle(label)]
                },
                [_vm._v("\n          " + _vm._s(label.text) + "\n        ")]
              )
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedExtraImages, function(img) {
            return [
              _c("img", {
                key: img.id,
                staticClass: "extra-image",
                style: [_vm.rectStyle(img), _vm.extraImageStyle(img)],
                attrs: { src: img.src, draggable: "false" }
              })
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedHotspots, function(hotspot) {
            return [
              _c("div", {
                key: hotspot.id,
                staticClass: "hotspot",
                style: [_vm.rectStyle(hotspot), _vm.hotspotStyle(hotspot)],
                on: {
                  mouseenter: function($event) {
                    return _vm.onEnter(hotspot)
                  },
                  mouseleave: function($event) {
                    return _vm.onLeave(hotspot)
                  },
                  click: function($event) {
                    return _vm.onClick(hotspot)
                  },
                  contextmenu: function($event) {
                    $event.preventDefault()
                    return _vm.onContextMenu(hotspot)
                  },
                  dblclick: function($event) {
                    $event.preventDefault()
                    return _vm.onDblClick(hotspot)
                  }
                }
              })
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedFields, function(field) {
            return [
              _c(
                "div",
                {
                  key: field.id,
                  staticClass: "field",
                  style: [_vm.rectStyle(field), _vm.fieldStyle(field)],
                  attrs: { "data-field-id": field.id }
                },
                [
                  field.type === "label"
                    ? _c(
                        "div",
                        {
                          staticClass: "field-label",
                          style: _vm.fieldLabelStyle(field)
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.form[field.model]) +
                              "\n          "
                          )
                        ]
                      )
                    : field.type !== "textarea" && field.type !== "select"
                    ? _c("input", {
                        staticClass: "field-input",
                        style: _vm.fieldInputStyle(field),
                        attrs: {
                          type: field.type || "text",
                          placeholder: field.placeholder,
                          autocomplete: field.autocomplete || "off",
                          "data-field-id": field.id
                        },
                        domProps: { value: _vm.form[field.model] },
                        on: {
                          input: function($event) {
                            return _vm.onFieldInput(field, $event)
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.onEnterSubmit(field)
                          }
                        }
                      })
                    : field.type === "select"
                    ? _c(
                        "select",
                        {
                          staticClass: "field-input field-select",
                          style: _vm.fieldInputStyle(field),
                          attrs: { "data-field-id": field.id },
                          domProps: { value: _vm.form[field.model] },
                          on: {
                            change: function($event) {
                              return _vm.onFieldInput(field, $event)
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(field.placeholder || "请选择"))
                          ]),
                          _vm._v(" "),
                          _vm._l(field.options || [], function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value || option,
                                domProps: { value: option.value || option }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(option.label || option) +
                                    "\n            "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _c("textarea", {
                        staticClass: "field-input field-textarea",
                        style: _vm.fieldInputStyle(field),
                        attrs: {
                          placeholder: field.placeholder,
                          "data-field-id": field.id
                        },
                        domProps: { value: _vm.form[field.model] },
                        on: {
                          input: function($event) {
                            return _vm.onFieldInput(field, $event)
                          }
                        }
                      })
                ]
              )
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.resolvedTables, function(table) {
            return [
              _c("SceneTable", {
                key: table.id,
                style: _vm.rectStyle(table),
                attrs: { config: table },
                on: {
                  "selection-change": function($event) {
                    return _vm.onTableSelectionChange(table, $event)
                  },
                  "cell-change": function($event) {
                    return _vm.onTableCellChange(table, $event)
                  },
                  "page-change": function($event) {
                    return _vm.onTablePageChange(table, $event)
                  }
                }
              })
            ]
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.showTip
      ? _c(
          "div",
          { staticClass: "tip" },
          [
            _vm._t("tip", function() {
              return [
                _c("div", { staticClass: "tip-title" }, [_vm._v("提示")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "tip-body",
                  domProps: { innerHTML: _vm._s(_vm.resolvedTip) }
                })
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e465850", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e465850","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simulate/StepPlayer.vue
// module id = 1291
// module chunks = 0